// @see https://en.wikipedia.org/wiki/Linear_interpolation

/**
 * Example usage: lerp(0, 10, 0.5) -> 5
 */
export function lerp(start: number, end: number, progress: number): number {
  return (1 - progress) * start + progress * end
}

/**
 * Example usage: inverseLerp(0, 10, 5) -> 0.5
 */
export function inverseLerp(start: number, end: number, value: number): number {
  return (value - start) / (end - start)
}
